module.exports = __webpack_public_path__ + "img/add-photo-fifth-icon-male.f2980881.svg";